/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pack: NonNullable<unknown> }} Receipt_Timeline_PagesInputs */



/**
* | output |
* | --- |
* | "Page pack {pack}" |
*
* @param {Receipt_Timeline_PagesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_timeline_pages = /** @type {((inputs: Receipt_Timeline_PagesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Timeline_PagesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Seitenpaket ${i?.pack}`)
	return /** @type {LocalizedString} */ (`Page pack ${i?.pack}`)
});